<template>
  <pu-modal
    :modal-hash="`confirm-delete-${hash}`"
    @open-modal="$emit('deleteModalOpened', $event)"
  >
    <template #modal-trigger>
      <slot name="modal-trigger">
        <img
          loading="lazy"
          src="~/assets/user-account/bin.svg"
          class="delete-icon"
        />
      </slot>
    </template>
    <p class="delete-modal-body">
      <slot />
    </p>
    <template #footer="{ closeModal }">
      <div class="delete-modal-buttons">
        <base-button css-class="minimal" @click="closeModal">
          <translate>Cancel</translate>
        </base-button>
        <base-button css-class="primary" @click="confirmDelete(closeModal)">
          <translate>Yes, delete it</translate>
        </base-button>
      </div>
    </template>
  </pu-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class DeleteButtonWithPrompt extends Vue {
  @Prop({ required: true })
  hash: string

  confirmDelete(closeModal) {
    closeModal()
    this.$emit('delete', this.hash)
  }
}

export default toNative(DeleteButtonWithPrompt)
</script>

<style scoped>
.delete-icon {
  width: 0.85em;
  margin: auto;
}

.delete-modal-body {
  background: white;
  padding: 3.5em 2em 2em;
  color: var(--colour-text-default);
  font-size: var(--large);
}

.delete-modal-buttons {
  padding: 1em 2em 2em;
  display: flex;
  justify-content: space-between;
}
</style>
